import { render, staticRenderFns } from "./OriginesChantierAdmin.vue?vue&type=template&id=4c351559&scoped=true&"
import script from "./OriginesChantierAdmin.vue?vue&type=script&lang=js&"
export * from "./OriginesChantierAdmin.vue?vue&type=script&lang=js&"
import style0 from "./OriginesChantierAdmin.vue?vue&type=style&index=0&id=4c351559&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c351559",
  null
  
)

export default component.exports